import { FC, ReactNode } from 'react'
import {
  Text,
  GreyGrey20,
  GreyGrey60,
  GreyGrey80,
  Primary13Regular,
  Flex
} from '@sequencehq/core-components'
import { TextOverflow } from '@sequencehq/core-components'
import { formatFileSizeToHumanReadable } from '@sequencehq/utils'

export const AttachmentUI: FC<{
  id: string
  name: string
  fileSizeBytes: number
  icon: ReactNode
  controls: ReactNode
  onClick?: () => void
}> = ({ id, name, fileSizeBytes, icon, controls, onClick }) => {
  return (
    <Flex
      gap={2}
      padding={2}
      mx={-2}
      borderRadius={4}
      alignItems="center"
      role="group"
      _hover={{ background: GreyGrey20 }}
      _focusWithin={{ background: GreyGrey20 }}
      onClick={onClick}
      cursor={onClick ? 'pointer' : 'default'}
      maxHeight="36px"
      data-testid={`attachment.item.${id}`}
    >
      {icon}
      <Text
        {...Primary13Regular}
        fontWeight="semibold"
        color={GreyGrey80}
        flex={1}
        overflow="hidden"
      >
        <TextOverflow splitPercentage={80}>{name}</TextOverflow>
      </Text>
      <Text {...Primary13Regular} color={GreyGrey60}>
        {formatFileSizeToHumanReadable(fileSizeBytes)}
      </Text>
      {controls}
    </Flex>
  )
}
